import { useState, useEffect } from 'react';

export const useResponsive = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => {
      // Use CSS media query to match the same breakpoint as CSS
      const mediaQuery = window.matchMedia('(max-width: 767px)');
      setIsMobile(mediaQuery.matches);
    };

    checkIsMobile();
    
    // Listen for media query changes
    const mediaQuery = window.matchMedia('(max-width: 767px)');
    mediaQuery.addEventListener('change', checkIsMobile);

    return () => mediaQuery.removeEventListener('change', checkIsMobile);
  }, []);

  return { isMobile };
};
